/* VikingsBrand Viking Quotes page — enhances the static (crawlable) quote cards with
   Younger Futhark runes + copy buttons, and runs the Phrase Forge (stylized word-for-word
   ON + runes + downloadable share card). Depends on vb-norse.js (window.VBNorse helpers)
   and vb-norse-data.js (curated dictionary core). Vanilla JS, no deps. */
(function () {
  'use strict';
  if (window.VBQuotes) { return; }
  window.VBQuotes = true;

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) { n.className = cls; }
    if (html !== undefined) { n.innerHTML = html; }
    return n;
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function copyText(txt, btn) {
    function done() {
      if (!btn) { return; }
      var old = btn.textContent;
      btn.textContent = 'COPIED ✓';
      setTimeout(function () { btn.textContent = old; }, 1400);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(txt).then(done, done);
    } else { done(); }
  }

  function boot(root) {
    if (!root || root.dataset.vbQuotesBoot === '1') { return; }
    root.dataset.vbQuotesBoot = '1';
    var R = window.VBNorse;
    if (!R || !R.toYounger) { return; }

    /* ---- runes + copy on every static quote card ---- */
    root.querySelectorAll('.vb-q-card[data-on]').forEach(function (card) {
      var on = card.dataset.on;
      var slot = card.querySelector('[data-vb="q-actions"]');
      if (!slot) { return; }
      var runes = R.toYounger(on);
      var rl = el('div', 'vb-nt-runes');
      var g = el('span', 'vb-nt-runeglyphs vb-q-runeglyphs', esc(runes));
      g.title = 'Younger Futhark — simplified Viking-Age spelling';
      rl.appendChild(g);
      var actions = el('span', 'vb-nt-copy');
      var b1 = el('button', 'vb-btn vb-btn--ghost', 'COPY');
      b1.type = 'button';
      b1.addEventListener('click', function () { copyText(on, b1); });
      var b2 = el('button', 'vb-btn vb-btn--ghost', 'COPY RUNES');
      b2.type = 'button';
      b2.addEventListener('click', function () { copyText(runes, b2); });
      actions.appendChild(b1); actions.appendChild(b2);
      rl.appendChild(actions);
      slot.appendChild(rl);
    });

    /* ---- Phrase Forge ---- */
    var forge = root.querySelector('#vb-forge');
    if (!forge) { return; }
    var DATA = window.VB_NORSE_DATA || { core: {} };
    var lookupUrl = forge.dataset.lookupUrl, LAZY = null;
    var input = forge.querySelector('[data-vb="forge-input"]');
    var out = forge.querySelector('[data-vb="forge-out"]');
    var dlBtn = forge.querySelector('[data-vb="forge-dl"]');
    var last = null;

    function getLazy() {
      if (LAZY) { return Promise.resolve(LAZY); }
      return fetch(lookupUrl).then(function (r) {
        if (!r.ok) { throw new Error('HTTP ' + r.status); }
        return r.json();
      }).then(function (j) { LAZY = j; return j; });
    }
    function normEn(w) { return w.toLowerCase().replace(/[^a-z\-']/g, ''); }
    function lookupWord(w, L) {
      var k = normEn(w);
      if (!k) { return null; }
      var tries = [k];
      if (/ves$/.test(k)) { tries.push(k.replace(/ves$/, 'f')); }
      if (/ies$/.test(k)) { tries.push(k.replace(/ies$/, 'y')); }
      if (/es$/.test(k)) { tries.push(k.slice(0, -2)); }
      if (/s$/.test(k)) { tries.push(k.slice(0, -1)); }
      for (var i = 0; i < tries.length; i++) {
        if (DATA.core[tries[i]]) { return DATA.core[tries[i]][0].on; }
        if (L && L[tries[i]]) { return L[tries[i]][0].on; }
      }
      return null;
    }
    /* the five honest futharks — no staveless (Unicode has no staveless glyphs; we don't fake them) */
    var FUTHARKS = [
      { key: 'younger', name: 'Younger Futhark', sub: 'the Viking Age', fn: function (s) { return R.toYounger(s); } },
      { key: 'shorttwig', name: 'Short-Twig', sub: 'Rök-style Younger', fn: function (s) { return R.toShortTwig(s); } },
      { key: 'medieval', name: 'Medieval Runerow', sub: 'c. 1100–1500', fn: function (s) { return R.toMedieval(s); } },
      { key: 'elder', name: 'Elder Futhark', sub: 'c. 150–800', fn: function (s) { return R.toFuthark(s, R.EF, R.EF_DI, false); } },
      { key: 'anglo', name: 'Anglo-Saxon Futhorc', sub: 'England & Frisia', fn: function (s) { return R.toFuthark(s, R.AF, R.AF_DI, true); } }
    ];
    var futhark = FUTHARKS[0];
    function run() {
      var q = input.value.trim();
      out.innerHTML = '';
      dlBtn.hidden = true;
      last = null;
      if (!q) { return; }
      var words = q.split(/\s+/).slice(0, 7);
      getLazy().catch(function () { return null; }).then(function (L) {
        var on = [], carried = [], skipped = 0;
        words.forEach(function (w) {
          /* "of/the/a/an" have no Old Norse word — the language says them with endings */
          if (/^(of|the|a|an)$/.test(normEn(w))) { skipped++; return; }
          var hit = lookupWord(w, L);
          /* no dictionary match → carry the word as-is (usually a name) and write it
             phonetically in runes, the way carvers wrote foreign names. Never guessed ON. */
          if (hit) { on.push(hit); } else { carried.push(normEn(w)); on.push(normEn(w)); }
        });
        if (!on.length) { return; }
        var onLine = on.join(' ');
        last = { en: q, on: onLine, runeSrc: onLine, runes: futhark.fn(onLine) };
        var missed = carried.length;
        var card = el('div', 'vb-nt-card vb-forge-card');
        card.appendChild(el('span', 'vb-nt-on vb-forge-on', esc(onLine)));
        var tabs = el('div', 'vb-futhark-tabs vb-forge-futharks');
        FUTHARKS.forEach(function (f) {
          var b = el('button', '', esc(f.name));
          b.type = 'button';
          b.title = f.sub;
          b.setAttribute('aria-pressed', String(f === futhark));
          b.addEventListener('click', function () {
            futhark = f;
            last.runes = f.fn(last.runeSrc);
            glyphEl.textContent = last.runes;
            tabs.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
          });
          tabs.appendChild(b);
        });
        card.appendChild(tabs);
        var glyphEl = el('div', 'vb-nt-runeglyphs vb-q-runeglyphs', esc(last.runes));
        card.appendChild(glyphEl);
        var msg = (missed ? '“' + esc(carried.join(', ')) + '” isn’t in the dictionary, so we kept it as-is and wrote it phonetically in runes — the way carvers wrote foreign names. Not a translation. ' : '') +
          (skipped ? 'English “of/the/a” were dropped — Old Norse says them with word endings, not separate words. ' : '');
        card.appendChild(el('p', 'vb-nt-note',
          '<span class="vb-nt-badge is-soft">stylized</span> Word-for-word, endings not inflected — art, not grammar. ' +
          msg + ' For grammatical lines use the quotes above, or look words up in the <a href="/pages/old-norse-translator">Old Norse Translator</a>.'));
        var actions = el('div', 'vb-nt-copy');
        var b1 = el('button', 'vb-btn vb-btn--ghost', 'COPY');
        b1.type = 'button';
        b1.addEventListener('click', function () { copyText(onLine, b1); });
        var b2 = el('button', 'vb-btn vb-btn--ghost', 'COPY RUNES');
        b2.type = 'button';
        b2.addEventListener('click', function () { copyText(last.runes, b2); });
        actions.appendChild(b1); actions.appendChild(b2);
        card.appendChild(actions);
        out.appendChild(card);
        dlBtn.hidden = false;
      });
    }
    var deb;
    input.addEventListener('input', function () { clearTimeout(deb); deb = setTimeout(run, 350); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); run(); } });
    var go = forge.querySelector('[data-vb="forge-go"]');
    if (go) { go.addEventListener('click', run); }

    /* share card: 1080×1080 PNG */
    dlBtn.addEventListener('click', function () {
      if (!last) { return; }
      var ready = (document.fonts && document.fonts.load)
        ? Promise.all([document.fonts.load('64px "Noto Sans Runic"'), document.fonts.load('600 60px Cinzel')]).catch(function () { return null; })
        : Promise.resolve();
      ready.then(function () {
        var S = 1080, c = document.createElement('canvas');
        c.width = S; c.height = S;
        var x = c.getContext('2d');
        x.fillStyle = '#14100e'; x.fillRect(0, 0, S, S);
        x.strokeStyle = 'rgba(216,188,142,.4)'; x.lineWidth = 2;
        x.strokeRect(46, 46, S - 92, S - 92);
        x.textAlign = 'center';
        x.fillStyle = '#B7A583';
        x.font = '600 26px Cinzel, serif';
        x.fillText('O L D   N O R S E', S / 2, 140);
        /* ON text, wrapped */
        x.fillStyle = '#F1E7D2';
        var size = last.on.length > 60 ? 44 : (last.on.length > 34 ? 54 : 66);
        x.font = '600 ' + size + 'px Cinzel, serif';
        var lines = wrap(x, last.on, S - 220);
        var y = S / 2 - (lines.length - 1) * (size * 0.66) - 60;
        lines.forEach(function (ln) { x.fillText(ln, S / 2, y); y += size * 1.32; });
        /* runes */
        x.fillStyle = '#C0432F';
        var rsize = last.runes.length > 40 ? 40 : 54;
        x.font = rsize + 'px "Noto Sans Runic", serif';
        var rlines = wrap(x, last.runes, S - 220);
        y += 26;
        rlines.forEach(function (ln) { x.fillText(ln, S / 2, y); y += rsize * 1.35; });
        x.fillStyle = '#8a7c66';
        x.font = '600 20px Cinzel, serif';
        x.fillText(futhark.name.toUpperCase(), S / 2, y + 4);
        /* EN + credit */
        x.fillStyle = '#8a7c66';
        x.font = 'italic 30px Georgia, serif';
        x.fillText('“' + last.en + '”', S / 2, S - 170);
        x.font = '24px Georgia, serif';
        x.fillText('vikingsbrand.co/pages/viking-quotes', S / 2, S - 96);
        var a = document.createElement('a');
        a.download = 'old-norse-' + last.en.toLowerCase().replace(/[^a-z0-9]+/g, '-').slice(0, 40) + '.png';
        a.href = c.toDataURL('image/png');
        a.click();
      });
    });
    function wrap(x, text, maxW) {
      var words = text.split(' '), lines = [], cur = '';
      words.forEach(function (w) {
        var t = cur ? cur + ' ' + w : w;
        if (x.measureText(t).width > maxW && cur) { lines.push(cur); cur = w; } else { cur = t; }
      });
      if (cur) { lines.push(cur); }
      return lines;
    }
  }

  function init() { document.querySelectorAll('#vb-quotes').forEach(boot); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
